import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    motorKeyValueAll: [],
    motorKeyValue: {},
    selectedCategory: {},
    currentPage: 1,
    totalPages: 1,
    rowsPerPage: 10,
    sortBy: "keyName",
    sortOrder: "asc",
};

const motorKeyValueSlice = createSlice({
    name: "motorKeyValue",
    initialState,
    reducers: {
        setMotorKeyValueAll: (state, action) => {
            state.motorKeyValueAll = action.payload;
        },
        setMotorKeyValue: (state, action) => {
            state.motorKeyValue = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
        setSelectedCategory: (state, action) => {
            state.selectedCategory = action.payload;
        },
    },
})

export const { setMotorKeyValueAll, setMotorKeyValue, setCurrentPage, setTotalPages, setRowsPerPage, setSelectedCategory } = motorKeyValueSlice.actions;
export default motorKeyValueSlice.reducer;